import FpPanel from './FpPanel.jsx'
export default FpPanel
